import React from 'react';
import { ButtonV2Props, SpacingStack, SpacingStackProps } from '@withjoy/joykit';
import { StyledCta } from './StepCtas.styles';

export const PrimaryCta = (props: ButtonV2Props) => <StyledCta {...props} intent="productive" />;

export const SecondaryCta = (props: ButtonV2Props) => <StyledCta {...props} intent="productive" variant="outline" />;

export const CtaGroup = (props: SpacingStackProps) => <SpacingStack spacing={5} {...props} />;
